module.exports = __webpack_public_path__ + "img/hr-tree-03-g-trunk.f372ce6c.png";